import { api } from "@/lib/api/client";
import type { components } from "@/types/api";
import type { StepUpProof } from "./stepup.api";

export type TotpSetupResponse = components["schemas"]["TotpSetupResponse"];
export type TotpVerifyResponse = components["schemas"]["TotpVerifyResponse"] & {
  recoveryCodesGeneration?: number;
};
export type DeleteTotpResponse = components["schemas"]["DeleteTotpResponse"];

export function startTotpSetup(): Promise<TotpSetupResponse> {
  return api.post<TotpSetupResponse>("/v1/mfa/totp/setup", undefined, { retrySafe: true });
}

export function verifyTotpSetup(code: string, stepUp?: StepUpProof): Promise<TotpVerifyResponse> {
  return api.post<TotpVerifyResponse>("/v1/mfa/totp/verify", {
    code,
    ...(stepUp ? { stepUp } : {}),
  });
}

export function deleteTotp(stepUp?: StepUpProof): Promise<DeleteTotpResponse> {
  return api.delete<DeleteTotpResponse>("/v1/mfa/totp", stepUp ? { body: { stepUp } } : undefined);
}
